module.exports = __webpack_public_path__ + "img/73.d7600678.png";